// API client — Publications mandat (Lot M4).
const BASE = process.env.REACT_APP_BACKEND_URL || "";

async function req(path, opts = {}) {
  const { method = "GET", body } = opts;
  const res = await fetch(`${BASE}${path}`, {
    method,
    credentials: "include",
    headers: { "Content-Type": "application/json" },
    body: body ? JSON.stringify(body) : undefined,
  });
  const text = await res.text();
  const data = text ? JSON.parse(text) : null;
  if (!res.ok) {
    const detail = data?.detail;
    const code = typeof detail === "object" ? detail?.code : undefined;
    const msg = typeof detail === "string" ? detail
             : detail?.message || code || `HTTP ${res.status}`;
    const err = new Error(msg);
    err.status = res.status;
    err.code = code;
    err.detail = detail;
    throw err;
  }
  return data;
}

export const mandatePublications = {
  get:        (mandateId) => req(`/api/mandates/${mandateId}/publications`),
  events:     (mandateId) => req(`/api/mandates/${mandateId}/publications/events`),
  catalog:    () => req(`/api/publications/channels/catalog`),
  addChannel: (mandateId, payload) =>
    req(`/api/mandates/${mandateId}/publications/channels`,
        { method: "POST", body: payload }),
  activate:   (mandateId, channel) =>
    req(`/api/mandates/${mandateId}/publications/channels/${channel}/activate`,
        { method: "POST" }),
  deactivate: (mandateId, channel) =>
    req(`/api/mandates/${mandateId}/publications/channels/${channel}/deactivate`,
        { method: "POST" }),
  updateListing: (mandateId, channel, patch) =>
    req(`/api/mandates/${mandateId}/publications/channels/${channel}`,
        { method: "PATCH", body: patch }),
};

export default mandatePublications;
